import { AuthProvider, SignInPage as AuthSignInPage } from '@hub-la/fe-auth'

export const SignInInit = () => {
  return (
    <AuthProvider>
      <AuthSignInPage />
    </AuthProvider>
  )
}
